export const ODOO_ONE_PAGER_URL = '/odoo/one-pager.html';
export const ODOO_SLIDE_DECK_URL = '/odoo/slide-deck.pptx';
export const ODOO_SLIDE_DECK_FILENAME = 'Kolanut_Odoo_Deck.pptx';

const DEFAULT_SITE_ORIGIN = 'https://www.kolanut.ai';

export const getOdooSlideDeckFileUrl = (origin = DEFAULT_SITE_ORIGIN) =>
  `${origin.replace(/\/$/, '')}${ODOO_SLIDE_DECK_URL}`;

const isLocalOrigin = (origin) =>
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(origin ?? '');

/** Office Online viewer — needs a publicly reachable HTTPS URL for the .pptx */
export const getOdooSlideDeckViewerUrl = (origin = DEFAULT_SITE_ORIGIN) => {
  const resolvedOrigin = isLocalOrigin(origin) ? DEFAULT_SITE_ORIGIN : origin;
  return `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(
    getOdooSlideDeckFileUrl(resolvedOrigin)
  )}`;
};

export const partnershipHighlights = [
  'Real time ad waste detection across Meta and Google',
  'Attribution that ties ad spend to real revenue',
  'AI recommendations for lean teams without a full marketing department',
  'Native integrations with Shopify, Square, and Boulevard',
];

export const integrationSteps = [
  'Kolanut ingests ad and commerce performance from Meta, Google, Shopify, Square, and Boulevard.',
  'Qualified leads and customers flow into Odoo CRM with full context.',
  'Revenue and order data from Odoo improves attribution and closes the loop.',
  'Marketing and ops share one growth view from acquisition to lifecycle.',
];

export const partnershipOpportunities = [
  {
    title: 'Native integration',
    body: 'App Store listing connecting acquisition intelligence into Odoo workflows.',
  },
  {
    title: 'Joint marketing',
    body: 'Webinars, SMB growth workshops, and shared case studies.',
  },
  {
    title: 'Referral network',
    body: 'Odoo implementation partners recommend Kolanut to customers who want to grow faster.',
  },
  {
    title: 'Bundled stack',
    body: 'A differentiated modern SMB growth stack: operations plus acquisition in one offer.',
  },
];

export const partnershipTags = [
  'Built with AI',
  'Built for SMBs',
  'Acquisition intelligence',
  'Revenue attribution',
  'Affordable',
  'Growth automation',
];
